import React, { useImperativeHandle, useRef, useState } from 'react';
import { Button, Input } from '@fx-ui/fine-design';
import classNames from 'classnames';
import { platformIntl } from '../../constants';
import { globalState } from '../../models';

interface IValidCodeProps {
    className?: string;
    height?: number | string;
    reloadTime?: number;
    waterMark?: string;
    defaultBtnText?: string;
    canGetCode?: boolean;
    codeValid?: boolean;
    tabIndex?: number;
    onChange?: (value: string) => void;
    onBtnClick?: () => void;
    onInputBlur?: () => void;
}

const ValidCode = React.forwardRef((props: IValidCodeProps, ref) => {
    const {
        className,
        height = 32,
        reloadTime = 60,
        waterMark = platformIntl.get('sms.verify.code'),
        defaultBtnText = platformIntl.get('verify.code.get'),
        canGetCode = true,
        codeValid = true,
        tabIndex,
        onChange,
        onBtnClick,
        onInputBlur
    } = props;
    const [inputValue, setInputValue] = useState<string>('');
    const [btnText, setBtnText] = useState<string>(defaultBtnText);
    // 是否处于倒计时状态
    const [isReloadTime, setIsReloadTime] = useState<boolean>(false);

    const thisRef = useRef<any>({
        timer: undefined
    });

    useImperativeHandle(ref, () => {
        return {
            setReloadState,
            clearReloadState
        };
    });

    const getAfterAddon = () => {
        // 可以获取验证码且不处于倒计时状态，按钮可以点击
        const disable = !canGetCode || isReloadTime;
        return (
            <Button
                className="valid-btn"
                type="negative"
                style={{
                    width: 120,
                    height: height
                }}
                disabled={disable}
                onClick={() => {
                    if (!disable && onBtnClick) {
                        return onBtnClick();
                    }
                }}
            >
                {btnText}
            </Button>
        );
    };

    const clearReloadState = () => {
        setBtnText(defaultBtnText);
        setInputValue('');
        setIsReloadTime(false);
        clearTimeout(thisRef.current.timer);
    };

    const setReloadState = () => {
        setIsReloadTime(true);
        setReloadTime(reloadTime);
    };

    const setReloadTime = (showNum: number) => {
        if (showNum > 0) {
            setBtnText(
                platformIntl.get('verify.code.get.again', {
                    num: showNum
                })
            );
            thisRef.current.timer = setTimeout(() => {
                setReloadTime(showNum - 1);
            }, 1000);
        } else {
            setBtnText(defaultBtnText);
            setIsReloadTime(false);
        }
    };

    return (
        <div
            className={classNames('fx-valid-code', {
                'is-mobile': globalState.isMobile
            })}
        >
            <Input
                className={classNames('code-input', className)}
                style={{ height: height }}
                placeholder={waterMark}
                value={inputValue}
                afterAddon={getAfterAddon()}
                inputState={codeValid ? 'normal' : 'error'}
                tabIndex={tabIndex}
                onChange={(val) => {
                    setInputValue(val);
                    if (onChange) {
                        onChange(val);
                    }
                }}
                onBlur={onInputBlur}
            />
        </div>
    );
});

export default ValidCode;
